@if (!isBulkEdit()) {
  <h2 mat-dialog-title>Edit file</h2>
} @else {
  <h2 mat-dialog-title>Edit multiple files</h2>
}

<mat-dialog-content>
  <form id="form" (submit)="submit($event)">
    @if (isLoading()) {
      <p>Files are being updated. Please wait...</p>
    } @else {
      @if (!isBulkEdit()) {
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Filename</mat-label>
            <input type="text" matInput [formField]="attachmentForm.filename" />
          </mat-form-field>
        </p>
      }

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Prefix</mat-label>
          <input type="text" matInput [formField]="attachmentForm.prefix" />
          @if (
            attachmentForm.prefix().errors().length &&
            attachmentForm.prefix().errors()[0].kind === 'prefix'
          ) {
            <mat-error>{{ attachmentForm.prefix().errors()[0].message }}</mat-error>
          }
          @if (isBulkEdit() && !attachmentForm.prefix().dirty()) {
            <mat-hint>Prefix will remain unchanged.</mat-hint>
          }
        </mat-form-field>
      </p>

      @if (!isBulkEdit()) {
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Title</mat-label>
            <input type="text" matInput [formField]="attachmentForm.title" />
          </mat-form-field>
        </p>
      }

      @if (!isBulkEdit()) {
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea rows="4" matInput [formField]="attachmentForm.description"></textarea>
          </mat-form-field>
        </p>
      }

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Release date</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            [formField]="attachmentForm.releaseDate"
            [max]="maxReleaseDate()"
          />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          @if (isBulkEdit() && !attachmentForm.releaseDate().dirty()) {
            <mat-hint>Release date will remain unchanged.</mat-hint>
          } @else {
            <mat-hint>YYYY-MM-DD</mat-hint>
          }
          @if (attachmentForm.releaseDate().errors().length) {
            <mat-error>Release date must be before {{ maxReleaseDate() | date }}.</mat-error>
          }
        </mat-form-field>
      </p>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <button
      mat-flat-button
      type="submit"
      form="form"
      [disabled]="attachmentForm().invalid() || !attachmentForm().dirty()"
    >
      Save
    </button>
    <button mat-button type="button" mat-dialog-close>Cancel</button>
  }
</mat-dialog-actions>
